import axios from 'axios'
// 数学建模 接口分隔

// import { Message, MessageBox } from 'element-ui'

let hostName
if (process.env.NODE_ENV === 'development') {
    // hostName = 'http://10.4.70.200:8080/api'
    // hostName = 'http://localhost:8080/api'
    hostName = 'https://slh8889.cm-qa.devlb.jsxfedu.net'
} else if (location.hostname.includes('.qalb')) { // 测试环境 bnujm.qalb.jsxfedu.net
    // hostName = 'https://jsxf-gateway-qa.qalb.jsxfedu.net'
    hostName = 'https://slh8889.cm-qa.devlb.jsxfedu.net'
} else if (location.hostname.includes('bnujm')) {// bnujm.jsxfedu.com
    // hostName = 'https://gw.jsxfedu.com'
    hostName = 'https://bnuexam.jsxfedu.com'
}
const service = axios.create({
    baseURL: hostName,
    timeout: 60000,
    withCredentials: true
    // headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
})
service.interceptors.request.use(config => {
    // console.log(config, 'config =============', location.hostname)
    if (config.type === '/gatewayApi') {
        // console.log(location, 'location =============')
        if (location.hostname === 'localhost') { // 本地开发
            // config.baseURL = 'http://10.10.11.43:18917'
            // config.baseURL = 'http://localhost:8080/gatewayApi'
            config.baseURL = 'https://jsxf-gateway-qa.qalb.jsxfedu.net'
        } else if (location.hostname.includes('.qalb')) { // 测试环境 bnujm.qalb.jsxfedu.net
            config.baseURL = 'https://jsxf-gateway-qa.qalb.jsxfedu.net'
            // config.baseURL = 'https://gw.jsxfedu.com'
        } else if (location.hostname.includes('bnujm')) {// bnujm.jsxfedu.com
            config.baseURL = 'https://gw.jsxfedu.com'
            // } else if (location.hostname === 'slh8889.cm-stg.prodpvtlb.jsxfedu.com') {
            //   config.baseURL = 'https://gw.jsxfedu.com'
        }
    }
    return config
})

// service.interceptors.response.use((response) => {
//   const res = response
//   if (res.status !== 200) {
//     Message({
//       message: res.message,
//       type: 'error',
//       duration: 5 * 1000
//     })
//   }
//   console.log(res, 'res ============')
// }, error => {
//   console.log('err' + error)// for debug
//   Message({
//     message: error.message,
//     type: 'error',
//     duration: 5 * 1000
//   })
//   return Promise.reject(error)
// })

// 专用请求cdn上的json
const serviceForJson = axios.create({
    baseURL: ''
})

function getJsonData(url) {
    return new Promise((resolve, reject) => {
        serviceForJson({
            method: 'get',
            url
        }).then((res) => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function get(url, params, baseUrl = '/api') {
    let headers = {}
    if (baseUrl === '/gatewayApi') {
        axios.defaults.headers.common['STU_UID'] = localStorage.getItem('STU_UID') || ''
        axios.defaults.headers.common['token'] = localStorage.getItem('token') || ''
        headers = {STU_UID: localStorage.getItem('STU_UID') || '', token: localStorage.getItem('token') || ''}
    }
    return new Promise((resolve, reject) => {
        service({
            method: 'get',
            url: url,
            params: params,
            type: baseUrl,
            headers
        }).then((res) => {
            // (resolve(res.data.data)) ||
            (res.data.code === 0 && resolve(res.data.data)) ||
                reject(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function post(url, params, baseUrl = '/api') {
    let headers = {}
    if (baseUrl === '/gatewayApi') {
        axios.defaults.headers.common['STU_UID'] = localStorage.getItem('STU_UID') || ''
        axios.defaults.headers.common['token'] = localStorage.getItem('token') || ''
        headers = {STU_UID: localStorage.getItem('STU_UID') || '', token: localStorage.getItem('token') || ''}
    }
    return new Promise((resolve, reject) => {
        service({
            method: 'post',
            url: url,
            params: params,
            type: baseUrl,
            headers
        }).then(res => {
            (res.data.code === 0 && resolve(res.data)) ||
                reject(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}
// 真正的post 新服务发现的问题
function gatewayApiPost(url, params, baseUrl = '/api') {
    let headers = {}
    if (params.headers) {
        headers = {...params.headers}
        delete params.headers
    }
    if (baseUrl === '/gatewayApi') {
        axios.defaults.headers.common['STU_UID'] = localStorage.getItem('STU_UID') || ''
        axios.defaults.headers.common['token'] = localStorage.getItem('token') || ''
        headers = {...headers, STU_UID: localStorage.getItem('STU_UID') || '', token: localStorage.getItem('token') || ''}
    }
    return new Promise((resolve, reject) => {
        service({
            method: 'post',
            url: url,
            data: params,
            type: baseUrl,
            headers
        }).then(res => {
            (res.data.code === 0 && resolve(res.data)) ||
                reject(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

// 处理文件逻辑
function gatewayApiPostFile(url, params, baseUrl = '/api') {
    let headers = {}
    if (baseUrl === '/gatewayApi') {
        axios.defaults.headers.common['STU_UID'] = localStorage.getItem('STU_UID') || ''
        axios.defaults.headers.common['token'] = localStorage.getItem('token') || ''
        headers = {STU_UID: localStorage.getItem('STU_UID') || '', token: localStorage.getItem('token') || ''}
    }
    return new Promise((resolve, reject) => {
        service({
            method: 'post',
            url: url,
            responseType: 'arraybuffer',
            data: params,
            type: baseUrl,
            headers
        }).then(res => {
            (res.status === 200 && resolve(res.data)) ||
                reject(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

// 并发执行
const axiosAll = params => {
    return new Promise((resolve, reject) => {
        axios.all(params)
            .then(axios.spread((...data) => {
                resolve(data)
            })).catch(err => {
                reject(err)
            })
    })
}

const newApplyInfo = params => get(`/registration-information/apply-info?${new Date().getTime()}`, params)

const reportPersonal = params => post(`/report/personal?${new Date().getTime()}`, params)
const reportClass = params => post(`/report/classReport?${new Date().getTime()}`, params)
const reportClassStatic = params => post(`/report/classStatic?${new Date().getTime()}`, params)
const getSchoolReport = params => post(`/report/schoolReport?${new Date().getTime()}`, params)
const getschoolStatic = params => post(`/report/schoolStatic?${new Date().getTime()}`, params)
const getAiToken = params => get(`/ai-report/get-token?${new Date().getTime()}`, params)
const getReportDownloadFile = params => get(`/get-report-downloadFile?${new Date().getTime()}`, params)
// 查询个人报告信息
const getOrderStatusAndSubject = params => post(`/ai-exam/get-order-status-and-subject?${new Date().getTime()}`, params)
// 查询班级年级报告信息
const getAuthorityByUserId = params => post(`/ai-exam/get-authority-by-userid?${new Date().getTime()}`, params)
const getAiReportList = params => post(`/ai-report/list?${new Date().getTime()}`, params)
const getStudentAuth = params => post(`/ai-report/studentAuth?${new Date().getTime()}`, params)
const getStudents = params => post(`/ai-report/students?${new Date().getTime()}`, params)
const getValidateTake = params => get(`/ai-report/validateTake?${new Date().getTime()}`, params)
const getStudentScore = params => get(`/ai-report/studentScore?${new Date().getTime()}`, params)
const getAddOrder = params => post(`/ai-exam/add-order?${new Date().getTime()}`, params)

// 报名系统
const getSumInfoCompleted = params => post(`/registration-information/get-sum-info-completed?${new Date().getTime()}`, params)
const getStartEndDate = params => post(`/competition-information/get-start-end-date?${new Date().getTime()}`, params)
const getGroupStatus = params => post(`/registration-information/get-group-status?${new Date().getTime()}`, params)
const groupToLocked = params => post(`/registration-information/update-info-group-to-locked?${new Date().getTime()}`, params)
const groupToUnlocked = params => post(`/registration-information/update-info-group-to-unlocked?${new Date().getTime()}`, params)
const payAndCheck = params => post(`/registration-information/pay-and-check?${new Date().getTime()}`, params)
const getTempInfos = params => post(`/registration-information/get-temp-infos?${new Date().getTime()}`, params)
const getTempInfo = params => post(`/registration-information/get-temp-info?${new Date().getTime()}`, params)
const userLogin = params => post(`/registration-information/verify-code-verification?${new Date().getTime()}`, params)
const downloadAnalysis = params => post(`/registration-information/download-and-analysis-excel?${new Date().getTime()}`, params)
const getFile = params => get(`/push-word-file?${new Date().getTime()}`, params)
const datestateUnlocked = params => post(`/registration-information/update-registration-information-datestate-to-unlocked?${new Date().getTime()}`, params)
const byidnumberAnd = params => post(`/registration-information/check-registration-information-by-idnumber-and-userid?${new Date().getTime()}`, params)
const datestate = params => post(`/registration-information/update-registration-information-datestate-to-locked?${new Date().getTime()}`, params)
const getInformationTime = params => post(`/competition-information/get-competition-information?${new Date().getTime()}`, params)
const userOrders = params => get(`/course-order/user-orders?${new Date().getTime()}`, params)
const addInformation = params => post(`/registration-information/add-or-update-registration-information?${new Date().getTime()}`, params)
const byUserid = params => post(`/registration-information/get-registration-information-by-userid?${new Date().getTime()}`, params)
const orderByOrderid = params => post(`/course-order/get-user-order-by-orderid?${new Date().getTime()}`, params)
const getUploadFileToken = params => get(`/base-api/get-token?${new Date().getTime()}`, params)
const saveFile = params => post(`/base-api/save-file?${new Date().getTime()}`, params)
const getStudentsList = params => post(`/registration-information/get-temp-info-problem?${new Date().getTime()}`, params)
const getGroupApplyInfo = params => post(`/registration-information/get-sum-info-all-completed?${new Date().getTime()}`, params)

// 通过token登陆
const loginToken = params => post(`/user/user-token-login?${new Date().getTime()}`, params)
const getImgVerify = params => post(`/get_img_verify?${new Date().getTime()}`, params)
const getSms = params => get(`/cerification-codeService/send-verification-code?${new Date().getTime()}`, params)
const getPri = params => get(`/file/pri-get?${new Date().getTime()}`, params)
const testImgVerify = params => post(`/test_img_verify?${new Date().getTime()}`, params)
const testSms = params => post(`/cerification-codeService/verify-code-verification?${new Date().getTime()}`, params)
const userRegister = params => post(`/user/user-register?${new Date().getTime()}`, params)
const getArea = params => get(`/city/get-city-list?${new Date().getTime()}`, params)
const getSchool = params => get(`/school/get-school?${new Date().getTime()}`, params)
const changePassword = params => post(`/user-password-operating/integrated-update-password?${new Date().getTime()}`, params)
const logout = params => post(`/login/logout?${new Date().getTime()}`, params)
const changeName = params => post(`/user/update-user-field?${new Date().getTime()}`, params)
const checkPhoneRegistState = params => get(`/user/check-user-phone?${new Date().getTime()}`, params)

const getDataMap = params => get(`/course-app/course-interface?${new Date().getTime()}`, params)
const getMessageList = params => get(`/leave-message/list-course-leave-message?${new Date().getTime()}`, params)
const getUserLesson = params => get(`/course-app/list-user-course?${new Date().getTime()}`, params)
const getStudyRecord = params => get(`/course-app/list-user-study-video?${new Date().getTime()}`, params)
const getVideoUrl = params => get(`/course-app/get-video-url?${new Date().getTime()}`, params)
// 添加订单
const addOrder = params => post(`/course-order/add-order?${new Date().getTime()}`, params)
// 添加支付方式并返回预支付信息
const payInfo = params => post(`/course-order/add-pay-type-and-back-pay-info?${new Date().getTime()}`, params)

const yinlianpayInfo = params => post(`/course-order/add-pay-type-and-back-pay-info?${new Date().getTime()}`, params)
// 同步订单(在用户支付完后,需要调用的接口)
const synchOrder = params => post(`/course-order/synch-order?${new Date().getTime()}`, params)

// 获取商品信息
const getGoodsData = params => get(`/course-app/get-course?${new Date().getTime()}`, params)
// 获取用户课程购买状态
const getUserGoodsStatus = params => get(`/course-app/get-user-course?${new Date().getTime()}`, params)
// 用户最近学习视频
const getLastStudyCourse = params => get(`/course-app/get-user-last-study-video?${new Date().getTime()}`, params)
const getCourseLastVideo = params => get(`/course-app/get-user-course-last-video?${new Date().getTime()}`, params)
const getStudyNum = params => get(`/course-app/course-study-num?${new Date().getTime()}`, params)
// 查询用户所在区县
const getStuCity = params => get(`/city/get-school-city?${new Date().getTime()}`, params)

const publishLeaveMsg = params => post(`/leave-message/add-leave-message?${new Date().getTime()}`, params)

// 课程点击记录
const courseClickRecord = params => post('/course-app/course-click', params)

const getCityList = params => get(`/city/get-city-list?${new Date().getTime()}`, params)
const getSchoolList = params => get(`/school/get-school?${new Date().getTime()}`, params)

// 查询成绩相关接口
const checkUserScore = param => get(`/check-user-score?${new Date().getTime()}`, param)
const checkUserBind = param => get(`/check-user-bind?${new Date().getTime()}`, param)
const getScore = params => get(`/search-score?${new Date().getTime()}`, params)
const bindSearchScore = params => get(`/bind-search-score?${new Date().getTime()}`, params)
const getUserInfo = params => get(`/get-user-info?${new Date().getTime()}`, params)
const enterByCode = params => get(`/enter-by-code?${new Date().getTime()}`, params)
const getNewsList = params => get(`/crm-consultation/list?${new Date().getTime()}`, params)
const getOpenZone = params => get(`/user-score/get-open-zone?${new Date().getTime()}`, params)
const addEnrollOrder = params => post(`/add-enroll-order?${new Date().getTime()}`, params)
const getAnswerList = params => get(`/crm-user-score/list-right-answer`, params)

// AI联考 - 个人统计报告
const getPersonalStat = params => post(`/get-personal-stat?${new Date().getTime()}`, params)

async function getCourseData2() {
}

// 物理考试系统gateway服务

// 物理考试报告证书查询
const certificateDownload = params => get(`/educational/report/download-zs?${new Date().getTime()}`, params, '/gatewayApi')
// 学生身份校验
const validIdentity = params => get(`/educational/cal/stu/valid-identity?${new Date().getTime()}`, params, '/gatewayApi')
const pretestCheck = params => get(`/educational/cal/answer/sub/test?${new Date().getTime()}`, params, '/gatewayApi')
// 根据当前登录人获取试卷
const getAnswerInfo = params => get(`/educational/cal/answer/info?${new Date().getTime()}`, params, '/gatewayApi')
const answerSubmitQuestion = params => gatewayApiPost(`/educational/cal/answer/submit/question?${new Date().getTime()}`, params, '/gatewayApi')
// 提交试卷
const answerSubmit = params => gatewayApiPost(`/educational/cal/answer/submit?${new Date().getTime()}`, params, '/gatewayApi')
// 查询考试状态
const getCompetitionInfo = params => get(`/educational/cal/competition/info?${new Date().getTime()}`, params, '/gatewayApi')
// 获取活动列表
const getCompetition = params => get(`/educational/cal/competition/list?${new Date().getTime()}`, params, '/gatewayApi')
// 考试报告查询
const getReportInfo = params => get(`/educational/report/report?${new Date().getTime()}`, params, '/gatewayApi')
// 考试报告查询
const getValidAnswer = params => get(`/educational/cal/stu/valid-answer?${new Date().getTime()}`, params, '/gatewayApi')
// 获取精品课程
const getPhyQuality = params => get(`/educational/physics/course/quality?${new Date().getTime()}`, params, '/gatewayApi')
// 获取课程列表
const getPhyCourseList = params => get(`/educational/physics/course/list?${new Date().getTime()}`, params, '/gatewayApi')
// 推荐课程
const getRecommendLesson = params => get(`/educational/physics/course/recommend/course?${new Date().getTime()}`, params, '/gatewayApi')
// 课程详情
const getCourseInfo = params => get(`/educational/physics/course/info?${new Date().getTime()}`, params, '/gatewayApi')
// 课程视频地址
const getCourseVideoUrl = params => get(`/educational/physics/course/detail-play?${new Date().getTime()}`, params, '/gatewayApi')
// 获取当前学生信息
const getStudentInfo = params => get(`/educational/cal/stu/current?${new Date().getTime()}`, params, '/gatewayApi')
// 同意承诺书
const agreeProtPocol = params => post(`/educational/cal/stu/agree-protocol?${new Date().getTime()}`, params, '/gatewayApi')
// 上传图片获取签名
const uploadSign = params => get(`/educational/cal/rs/uploadSign?${new Date().getTime()}`, params, '/gatewayApi')
const answerFace = params => get(`/educational/cal/answer/face?${new Date().getTime()}`, params, '/gatewayApi')
// 数据建模前测上传图片
const answerStudentFace = params => get(`/educational/cal/sxjmv3/activity/face?${new Date().getTime()}`, params, '/gatewayApi')
// 记录中断记录
const answerInterrupt = params => get(`/educational/cal/answer/interrupt?${new Date().getTime()}`, params, '/gatewayApi')
// 获取考试button
const stageButton = params => get(`/educational/cal/stage/button?${new Date().getTime()}`, params, '/gatewayApi')
// 查询是否绑定学生信息
const reportIsBanding = params => get(`/educational/report/is-banding?${new Date().getTime()}`, params, '/gatewayApi')
// 是否绑定-新
const reportIsBind = params => get(`/educational/report/is-bind?${new Date().getTime()}`, params, '/gatewayApi')
// 绑定学生信息
const reportBandingStudent = params => gatewayApiPost(`/educational/report/banding-student?${new Date().getTime()}`, params, '/gatewayApi')
// 考试报告列表
const getReportList = params => get(`/educational/report/list?${new Date().getTime()}`, params, '/gatewayApi')
// 是否可查询报告
const isQueryReport = params => get(`/educational/report/is-query?${new Date().getTime()}`, params, '/gatewayApi')
// 创建订单
const addPhyOrder = params => post(`/course-order/add-phy-order?${new Date().getTime()}`, params)

// 本地调试用，提交时注释下面代码
// const getPhyQuality = params => get(`/physics/course/quality?${new Date().getTime()}`, params, '/gatewayApi')
// const getPhyCourseList = params => get(`/physics/course/list?${new Date().getTime()}`, params, '/gatewayApi')
// const getRecommendLesson = params => get(`/physics/course/recommend/course?${new Date().getTime()}`, params, '/gatewayApi')
// const getCourseInfo = params => get(`/physics/course/info?${new Date().getTime()}`, params, '/gatewayApi')
// const getCourseVideoUrl = params => get(`/physics/course/detail-play?${new Date().getTime()}`, params, '/gatewayApi')
// const getCompetitionInfo = params => get(`/cal/competition/info?${new Date().getTime()}`, params, '/gatewayApi')
// const getCompetition = params => get(`/cal/competition/list?${new Date().getTime()}`, params, '/gatewayApi')
// const validIdentity = params => get(`/cal/stu/valid-identity?${new Date().getTime()}`, params, '/gatewayApi')
// const pretestCheck = params => get(`/cal/answer/sub/test?${new Date().getTime()}`, params, '/gatewayApi')
// const getAnswerInfo = params => get(`/cal/answer/info?${new Date().getTime()}`, params, '/gatewayApi')
// const answerSubmitQuestion = params => gatewayApiPost(`/cal/answer/submit/question?${new Date().getTime()}`, params, '/gatewayApi')
// const answerSubmit = params => gatewayApiPost(`/cal/answer/submit?${new Date().getTime()}`, params, '/gatewayApi')
// const getReportInfo = params => get(`/report/report?${new Date().getTime()}`, params, '/gatewayApi')
// const getValidAnswer = params => get(`/cal/stu/valid-answer?${new Date().getTime()}`, params, '/gatewayApi')
// const getStudentInfo = params => get(`/cal/stu/current?${new Date().getTime()}`, params, '/gatewayApi')
// const agreeProtPocol = params => post(`/cal/stu/agree-protocol?${new Date().getTime()}`, params, '/gatewayApi')
// const uploadSign = params => get(`/cal/rs/uploadSign?${new Date().getTime()}`, params, '/gatewayApi')
// const answerFace = params => get(`/cal/answer/face?${new Date().getTime()}`, params, '/gatewayApi')
// const answerInterrupt = params => get(`/cal/answer/interrupt?${new Date().getTime()}`, params, '/gatewayApi')
// const stageButton = params => get(`/cal/stage/button?${new Date().getTime()}`, params, '/gatewayApi')
// const reportIsBanding = params => get(`/report/is-banding?${new Date().getTime()}`, params, '/gatewayApi')
// const reportIsBind = params => get(`/report/is-bind?${new Date().getTime()}`, params, '/gatewayApi')
// const reportBandingStudent = params => gatewayApiPost(`/report/banding-student?${new Date().getTime()}`, params, '/gatewayApi')
// const getReportList = params => get(`/report/list?${new Date().getTime()}`, params, '/gatewayApi')
// const isQueryReport = params => get(`/report/is-query?${new Date().getTime()}`, params, '/gatewayApi')

// 高考大讲堂 =================================================================

// 最新推荐
const getLessonRecommend = params => get(`/educational/cal/course/index/quality?${new Date().getTime()}`, params, '/gatewayApi')
// 热销资源
const getHotSale = params => get(`/educational/cal/course/index/hot-sale?${new Date().getTime()}`, params, '/gatewayApi')
// 高考文档
const getTestPaperRecommend = params => get(`/educational/cal/course/index/quality-paper?${new Date().getTime()}`, params, '/gatewayApi')
// 资源列表
const getResourcesList = params => get(`/educational/cal/course/list?${new Date().getTime()}`, params, '/gatewayApi')
// 课程详情
const getLessonInfo = params => get(`/educational/cal/course/info?${new Date().getTime()}`, params, '/gatewayApi')
// 课程视频 (试卷)地址
const getLessonVideoUrl = params => get(`/educational/course/detail-play?${new Date().getTime()}`, params, '/gatewayApi')
// 激活码
const getActivateCode = params => gatewayApiPost(`/educational/activate-code/active-course?${new Date().getTime()}`, params, '/gatewayApi')
// 激活码历史
const getActivatedHistory = params => get(`/educational/personal/activated-history?${new Date().getTime()}`, params, '/gatewayApi')
// 我的课程
const getPersonalMyLesson = params => get(`/educational/personal/my-courses?${new Date().getTime()}`, params, '/gatewayApi')
// 我的试卷
const getPersonalMyPapers = params => get(`/educational/personal/my-papers?${new Date().getTime()}`, params, '/gatewayApi')
// 创建订单
const addGkOrder = params => post(`/course-order/add-gk-order?${new Date().getTime()}`, params)
const addGkBookOrder = params => post(`/course-order/add-gk-book-order?${new Date().getTime()}`, params)
// 查询我的订单
const getPersonalMyOrder = params => get(`/educational/personal/my-orders?${new Date().getTime()}`, params, '/gatewayApi')
const getAddress = params => get(`/educational/address?${new Date().getTime()}`, params, '/gatewayApi')
const addressSave = params => gatewayApiPost(`/educational/address?${new Date().getTime()}`, params, '/gatewayApi')
// 获取订单详情
const getPersonalMyOrderDetail = params => get(`/educational/personal/order-detail?${new Date().getTime()}`, params, '/gatewayApi')
// 获取精品课程
const getQuality = params => get(`/educational/cal/course/index/quality?${new Date().getTime()}`, params, '/gatewayApi')
// 轮播图
const getLectureHallBanner = params => get(`/educational/banner/list?${new Date().getTime()}`, params, '/gatewayApi')
// 获取优质试卷
const getQualityPaper = params => get(`/educational/cal/course/index/quality-paper?${new Date().getTime()}`, params, '/gatewayApi')
// 获取试卷pdf
const getFilePaperUrl = params => get(`/educational/rs/get-file-url?${new Date().getTime()}`, params, '/gatewayApi')
// 获取特色文章
const getQualityWz = params => get(`/educational/cal/course/index/quality-wz?${new Date().getTime()}`, params, '/gatewayApi')
const getRecommendArticles = params => get(`/educational/cal/course/recommend/article?${new Date().getTime()}`, params, '/gatewayApi')

// 获取教辅图书
const getQualityJfts = params => get(`/educational/cal/course/index/quality-jfts?${new Date().getTime()}`, params, '/gatewayApi')
const getJftsList = params => get(`/educational/gk-book/page-list?${new Date().getTime()}`, params, '/gatewayApi')
// 获取图书详情
const getJftsDetails = params => get(`/educational/gk-book/get-book-by-id?${new Date().getTime()}`, params, '/gatewayApi')
// 热门试卷
const recommendPaper = params => get(`educational/cal/course/recommend/paper?${new Date().getTime()}`, params, '/gatewayApi')
// 热门图书
const getPopularBook = params => get(`/educational/gk-book/get-popular-books?${new Date().getTime()}`, params, '/gatewayApi')
// 推荐课程
const recommendLesson = params => get(`/educational/cal/course/recommend/course?${new Date().getTime()}`, params, '/gatewayApi')
// 获取专题推荐
const getQualityZttj = params => get(`/educational/cal/course/index/quality-zttj?${new Date().getTime()}`, params, '/gatewayApi')
const getSpecialList = params => get(`/educational/gk-special/page-list?${new Date().getTime()}`, params, '/gatewayApi')
const getSpecialDetails = params => get(`/educational/gk-special/get-special-details-front?${new Date().getTime()}`, params, '/gatewayApi')

// 数学建模 ---------------------------------
// SSE下载团队证书（使用 fetch + ReadableStream 携带 token）
const downloadTeamCertificateSSE = (certType, batchNo, callbacks) => {
    // 获取 gateway baseURL，与 interceptors 中逻辑保持一致
    let gatewayBaseURL
    if (location.hostname === 'localhost') {
        gatewayBaseURL = 'https://jsxf-gateway-qa.qalb.jsxfedu.net'
    } else if (location.hostname.includes('.qalb')) {
        gatewayBaseURL = 'https://jsxf-gateway-qa.qalb.jsxfedu.net'
    } else if (location.hostname.includes('bnujm')) {
        gatewayBaseURL = 'https://gw.jsxfedu.com'
    } else {
        gatewayBaseURL = hostName // fallback
    }

    const token = localStorage.getItem('token') || ''
    const stuUid = localStorage.getItem('STU_UID') || ''
    const url = `${gatewayBaseURL}/educational/sxjm/student/download-team-certificate/${certType}/${batchNo}`

    const controller = new AbortController()

    fetch(url, {
        headers: {
            'token': token,
            'STU_UID': stuUid,
        },
        signal: controller.signal,
        credentials: 'include',
    }).then(async (response) => {
        if (!response.ok) {
            callbacks.onError && callbacks.onError(`请求失败，状态码：${response.status}`)
            return
        }
        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''

        // eslint-disable-next-line no-constant-condition
        while (true) {
            const { done, value } = await reader.read()
            if (done) break

            buffer += decoder.decode(value, { stream: true })

            // 按双换行分割 SSE 消息
            const parts = buffer.split('\n\n')
            buffer = parts.pop() || '' // 保留最后不完整的片段

            for (const part of parts) {
                if (!part.trim()) continue
                let eventType = 'message'
                let data = ''
                const lines = part.split('\n')
                for (const line of lines) {
                    if (line.startsWith('event:')) {
                        eventType = line.slice(6).trim()
                    } else if (line.startsWith('data:')) {
                        data = line.slice(5).trim()
                    }
                }
                if (callbacks[eventType]) {
                    callbacks[eventType](data)
                }
            }
        }
    }).catch((err) => {
        if (err.name !== 'AbortError') {
            callbacks.onError && callbacks.onError(err.message || '连接失败')
        }
    })

    // 返回 abort 函数，用于取消连接
    return () => controller.abort()
}
const sxjmcardquery = params => gatewayApiPost(`/educational/sxjm/?${new Date().getTime()}`, params, '/gatewayApi')
const getProvinceLogin = params => get(`/educational/dic/city/get-province-login?${new Date().getTime()}`, params, '/gatewayApi')
const getSubDistrict = params => get(`/educational/dic/city/get-sub-district?${new Date().getTime()}`, params, '/gatewayApi')
const getSchoolList2 = params => get(`/educational/dic/school/list?${new Date().getTime()}`, params, '/gatewayApi')
// const sxjmPaperSubmit = params => gatewayApiPost(`/educational/sxjm/paper/submit?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmPaperSubmit = params => gatewayApiPost(`/educational/v2/sxjm/paper/submit?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmPaperInfo = params => get(`/educational/sxjm/paper/info?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmPaperList = params => get(`/educational/sxjm/paper/my-list?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmPaperScheduler = params => get(`/educational/sxjm/paper/scheduler?${new Date().getTime()}`, params, '/gatewayApi')
const getActivityDetails = params => get(`/educational/sxjm/activity/details?${new Date().getTime()}`, params, '/gatewayApi')
const getActivityYears = params => get(`/educational/sxjm/activity/years?${new Date().getTime()}`, params, '/gatewayApi')
const getActivityDetailsPage = params => get(`/educational/sxjm/activity/details/page?${new Date().getTime()}`, params, '/gatewayApi')
const getExamInfo = params => get(`/educational/sxjm/exam-info?${new Date().getTime()}`, params, '/gatewayApi')
const getExamScore = params => get(`/educational/sxjm/exam-score?${new Date().getTime()}`, params, '/gatewayApi')
const getPaperSubState = params => get(`/educational//sxjm/paper/paper-sub-state?${new Date().getTime()}`, params, '/gatewayApi')
const getPaperAward = params => get(`/educational//sxjm/paper/paper-award?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmTeacherPaperList = params => get(`/educational/sxjm/teacher/paper/my-list?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmTeacherPaperInfo = params => get(`/educational/sxjm/teacher/paper/info?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmTeacherPaperSubmit = params => gatewayApiPost(`/educational/sxjm/teacher/paper/submit?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmQueryPersonalInformation = params => get(`/educational/sxjm/student/v3-get-self-enroll?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmGetRegion = params => get(`/educational/cal/sxjmv3/area?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmGetSchool = params => get(`/educational/sxjm/school/get-school-by-area?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmGetindivSchool = params => get(`/educational/sxjm/school/get-base-school-by-area-code?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmFinalSubmission = params => gatewayApiPost(`/educational/sxjm/student/v3-individual-enroll?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmvalidIdentity = params => gatewayApiPost(`/educational/cal/sxjmv3/activity/valid-identity?${new Date().getTime()}`, params, '/gatewayApi')
// const sxjmvalidIdentity = params => gatewayApiPost(`http://10.4.68.18:8917/cal/sxjmv3/activity/valid-identity?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmGroupImport = params => gatewayApiPost(`/educational/sxjm/student/v3-group-enroll?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmconfirm = params => gatewayApiPost(`/educational/sxjm/student/v3-group-enroll-confirm?${new Date().getTime()}`, params, '/gatewayApi')
const sxjmGetGroupList = params => get(`/educational/sxjm/student/v3-group-list`, params, '/gatewayApi')
const getServerTime = params => get(`/educational/cal/sxjmv3/activity/sytem-time`, params, '/gatewayApi')
// const sxjmExport = params => gatewayApiPostFile(`/educational/sxjm/student/v3-group-export/v2`, params, '/gatewayApi')
const sxjmExport = params => gatewayApiPostFile(`/educational/sxjm/student/download-team-score/` +params.batchNo , params, '/gatewayApi')

// const sxjmExport = params => gatewayApiPostFile(`http://10.4.68.18:8917/sxjm/student/v3-group-export`, params, '/gatewayApi')
const islogin = params => get(`/is/login?${new Date().getTime()}`, params)
const login = params => post(`/user/user-login?${new Date().getTime()}`, params)
const loginV2 = params => gatewayApiPost(`/educational/login/?${new Date().getTime()}`, params, '/gatewayApi')
const sendLoginCode = params => gatewayApiPost(`/educational/login/send-login-code?${new Date().getTime()}`, params, '/gatewayApi')
const getCurrentUser = params => get(`/educational/user/current-user?${new Date().getTime()}`, params, '/gatewayApi')
const getGroupList = params => get(`/educational/sxjm/student/v3-group-list/v2`, params, '/gatewayApi')
const getVerifyCode = params => get(`/educational/code/${params.type}?${new Date().getTime()}`, params, '/gatewayApi')
const forgetPwd = params => gatewayApiPost(`/educational/user/forget-pwd?${new Date().getTime()}`, params, '/gatewayApi')
const loginV3 = params => gatewayApiPost(`/educational/user/login?${new Date().getTime()}`, params, '/gatewayApi')
const regist = params => gatewayApiPost(`/educational/user/register?${new Date().getTime()}`, params, '/gatewayApi')
const sendPhoneCode = params => gatewayApiPost(`/educational/user/send-phone-code?${new Date().getTime()}`, params, '/gatewayApi')
export default {
    downloadTeamCertificateSSE,
    sendPhoneCode,
    regist,
    loginV3,
    forgetPwd,
    getVerifyCode,
    gatewayApiPost,
    get,
    sxjmGetindivSchool,
    answerStudentFace,
    sxjmvalidIdentity,
    sxjmExport,
    sxjmGetGroupList,
    sxjmconfirm,
    sxjmGroupImport,
    sxjmFinalSubmission,
    sxjmGetSchool,
    sxjmGetRegion,
    sxjmQueryPersonalInformation,
    sxjmTeacherPaperSubmit,
    sxjmTeacherPaperInfo,
    sxjmTeacherPaperList,
    getExamScore,
    getPaperAward,
    getPaperSubState,
    getExamInfo,
    getActivityDetailsPage,
    getActivityYears,
    getActivityDetails,
    sxjmPaperScheduler,
    sxjmPaperList,
    sxjmPaperInfo,
    sxjmPaperSubmit,
    getSchoolList2,
    getSubDistrict,
    getProvinceLogin,
    sxjmcardquery,
    answerInterrupt,
    answerFace,
    uploadSign,
    axiosAll,
    login,
    loginV2,
    sendLoginCode,
    getCityList,
    getSchoolList,
    // getCourseData,
    getCourseData2,
    getLastStudyCourse,
    getCourseLastVideo,
    getStudyRecord,
    publishLeaveMsg,
    getVideoUrl,
    getDataMap,
    getJsonData,
    getUserLesson,
    getGoodsData,
    getUserGoodsStatus,
    getStudyNum,
    courseClickRecord,
    addOrder,
    payInfo,
    yinlianpayInfo,
    synchOrder,
    getMessageList,
    islogin,
    getImgVerify,
    testImgVerify,
    getPri,
    getSms,
    changePassword,
    testSms,
    userRegister,
    checkPhoneRegistState,
    getArea,
    getSchool,
    logout,
    loginToken,
    getStuCity,
    changeName,
    checkUserScore,
    checkUserBind,
    getScore,
    bindSearchScore,
    getUserInfo,
    enterByCode,
    getNewsList,
    getOpenZone,
    addEnrollOrder,
    getAnswerList,
    getInformationTime,
    addInformation,
    datestate,
    byidnumberAnd,
    datestateUnlocked,
    byUserid,
    orderByOrderid,
    userOrders,
    getUploadFileToken,
    saveFile,
    downloadAnalysis,
    getFile,
    getStudentsList,
    getGroupApplyInfo,
    userLogin,
    getTempInfos,
    payAndCheck,
    getTempInfo,
    groupToLocked,
    groupToUnlocked,
    getGroupStatus,
    getStartEndDate,
    getSumInfoCompleted,
    getPersonalStat,
    reportPersonal,
    newApplyInfo,
    reportClass,
    reportClassStatic,
    getSchoolReport,
    getschoolStatic,
    getOrderStatusAndSubject,
    getAuthorityByUserId,
    getAiReportList,
    getStudentAuth,
    getStudents,
    getStudentScore,
    getValidateTake,
    getAddOrder,
    getAiToken,
    getReportDownloadFile,
    validIdentity,
    certificateDownload,
    pretestCheck,
    getAnswerInfo,
    getCompetitionInfo,
    answerSubmit,
    answerSubmitQuestion,
    getReportInfo,
    getValidAnswer,
    getLessonRecommend,
    getHotSale,
    getTestPaperRecommend,
    getResourcesList,
    getLessonInfo,
    getLessonVideoUrl,
    getActivateCode,
    getActivatedHistory,
    getPersonalMyLesson,
    getPersonalMyPapers,
    addGkOrder,
    addGkBookOrder,
    getPersonalMyOrder,
    getAddress,
    addressSave,
    getPersonalMyOrderDetail,
    getQuality,
    getQualityPaper,
    getFilePaperUrl,
    getLectureHallBanner,
    // getTestpaperList,
    getQualityWz,
    getRecommendArticles,
    reportIsBanding,
    reportBandingStudent,
    getQualityJfts,
    getJftsList,
    getJftsDetails,
    recommendPaper,
    getPopularBook,
    recommendLesson,
    getQualityZttj,
    getSpecialList,
    getSpecialDetails,
    getStudentInfo,
    agreeProtPocol,
    stageButton,
    getPhyQuality,
    getPhyCourseList,
    getRecommendLesson,
    getCourseInfo,
    getCourseVideoUrl,
    addPhyOrder,
    getCompetition,
    reportIsBind,
    getReportList,
    getServerTime,
    isQueryReport,
    getCurrentUser,
    getGroupList
}
